// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.help-section h2 {
  -webkit-text-fill-color: #fff;
  font-weight: 500;
  font-size: 30px;
}
.help-section .help-card {
  background: rgba(46, 159, 196, 0.6980392157);
  border-radius: 24px;
  max-width: 1010px;
  width: 100%;
  margin: 0 auto;
  padding: 40px;
}
.help-section .row-container {
  padding-top: 24px;
  display: flex;
  justify-content: space-between;
  flex-direction: row-reverse;
}
.help-section .custom-card {
  background: #fff;
}
.help-section h3 {
  font-size: 16px;
  color: #fff;
}

@media only screen and (min-width: 0px) and (max-width: 1024px) {
  .help-section .row-container {
    padding-top: 24px;
  }
}
@media only screen and (min-width: 0px) and (max-width: 768px) {
  .help-section .row-container {
    flex-wrap: wrap;
    flex-direction: row;
  }
}
@media only screen and (min-width: 0px) and (max-width: 767px) {
  .help-section h3 {
    font-size: 14px;
  }
}`, "",{"version":3,"sources":["webpack://./src/Components/HelpSection/HelpSection.scss"],"names":[],"mappings":"AACE;EACE,6BAAA;EACA,gBAAA;EACA,eAAA;AAAJ;AAEE;EACE,4CAAA;EACA,mBAAA;EACA,iBAAA;EACA,WAAA;EACA,cAAA;EACA,aAAA;AAAJ;AAEE;EACE,iBAAA;EACA,aAAA;EACA,8BAAA;EACA,2BAAA;AAAJ;AAEE;EACE,gBAAA;AAAJ;AAEE;EACE,eAAA;EACA,WAAA;AAAJ;;AAOA;EAEI;IACI,iBAAA;EALN;AACF;AAQA;EAEI;IACI,eAAA;IACA,mBAAA;EAPN;AACF;AAUA;EAEI;IACI,eAAA;EATN;AACF","sourcesContent":[".help-section{\r\n  h2{\r\n    -webkit-text-fill-color:#fff;\r\n    font-weight: 500;\r\n    font-size: 30px;\r\n  }\r\n  .help-card{\r\n    background: #2E9FC4B2;\r\n    border-radius: 24px;\r\n    max-width: 1010px;\r\n    width: 100%;\r\n    margin: 0 auto;\r\n    padding: 40px;\r\n  }\r\n  .row-container{\r\n    padding-top: 24px;\r\n    display: flex;\r\n    justify-content: space-between;\r\n    flex-direction: row-reverse;\r\n  }\r\n  .custom-card{\r\n    background: #fff;\r\n  }\r\n  h3{\r\n    font-size: 16px;\r\n    color: #fff;\r\n  }\r\n}\r\n\r\n\r\n\r\n\r\n@media only screen and (min-width: 0px) and (max-width: 1024px) {\r\n  .help-section{\r\n    .row-container{\r\n        padding-top: 24px;\r\n    }\r\n  }\r\n}\r\n@media only screen and (min-width: 0px) and (max-width: 768px) {\r\n  .help-section{\r\n    .row-container{\r\n        flex-wrap: wrap;\r\n        flex-direction: row;\r\n    }\r\n  }\r\n}\r\n@media only screen and (min-width: 0px) and (max-width: 767px) {\r\n  .help-section{\r\n    h3{\r\n        font-size: 14px;\r\n    }\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
